<template>
  <v-navigation-drawer app :rail="isRail" expand-on-hover color="primary" permanent>
    <v-list>
      <v-list-item title="saineo" style="cursor: pointer;" @click="$router.push('/')">
        <template #prepend>
          <v-avatar size="32">
            <v-img :src="logoSrc" alt="Logo Saineo" />
          </v-avatar>
        </template>
      </v-list-item>
      <v-list-item @click="isRail = !isRail" style="cursor:pointer">
        <template #prepend>
          <v-icon size="18">{{ isRail ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
        </template>
      </v-list-item>
    </v-list>
    <v-list density="compact" nav>
      <v-list-item
        v-for="(menu, index) in menus"
        :key="index"
        :to="menu.link"
        :prepend-icon="menu.prependIcon"
        :class="{ 'active-menu': $route.path === menu.link }"
      >
        <v-list-item-title>{{ menu.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
    <template #append>
      <v-list density="compact" nav>
        <v-list-item
          prepend-icon="mdi-logout"
          @click="logout"
          style="cursor: pointer;"
          title="Déconnexion"
        />
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { useAuthStore } from "@/store/auth_store";
import { getAuth } from "firebase/auth";
import { ref, computed } from "vue";
import { useTheme } from "vuetify";
import logoUrl from "@/assets/logo.png";
import lightLogoUrl from "@/../assets/lightLogo.png";

export default {
  name: "NavBarUser",
  setup() {
    const theme = useTheme();
    const isRail = ref(true);
    const authStore = useAuthStore();
    const menus = ref([
      {
        title: "Dashboard",
        link: "/",
        prependIcon: "mdi-view-dashboard-outline",
      },
      {
        title: "Mon profil",
        link: "/profile",
        prependIcon: "mdi-account-outline",
      },
      {
        title: "Mes ingrédients",
        link: "/my_ingredients",
        prependIcon: "mdi-food-apple-outline",
      },
      {
        title: "Mes recettes",
        link: "/my_recipes",
        prependIcon: "mdi-book-outline",
      },
      {
        title: "Mon menu",
        link: "/menu",
        prependIcon: "mdi-clipboard-list-outline",
      },
      {
        title: "Ma liste de courses",
        link: "/shopping_list",
        prependIcon: "mdi-cart-outline",
      },
    ]);

    const logout = () => {
      const auth = getAuth();
      auth
        .signOut()
        .then(() => (window.location.href = "#/welcome"))
        .catch((error) => console.error("Error signing out: ", error));
    };

    const logoSrc = computed(() =>
      theme.global.name.value === "dark" ? lightLogoUrl : logoUrl
    );

    return {
      authStore,
      isRail,
      menus,
      logout,
      logoSrc,
    };
  },
};
</script>

<style scoped>
.active-menu {
  background-color: #F5F1EE !important;
  border-radius: 8px;
}

.active-menu .v-icon {
  color: #1A1615 !important;
}

:deep(.v-list-item-title) {
  font-size: 13px !important;
  font-family: "Open Runde", "Montserrat", sans-serif !important;
  font-weight: 400 !important;
}
</style>
